<template>
  <div class="project-app">
    <My-new-nav ref="header" menuTheme="dark"></My-new-nav>
    <div class="solution-cont">
      <div class="banner-title">加入我们</div>
      <div class="banner-message">寻找特别的您，这里有属于您的位置！</div>
    </div>
    <div class="card">
      <ecn-title title="招聘通道"></ecn-title>
      <div class="recruit_channel">
        <div class="channel-item" style="margin-right: 4vw;" @click="toRecruit">
          <img class="channel_bg" src="../../../assets/image/Mobile/joinUs/joinUs_channel1.png" alt="">
          <div class="channel_text">
            <img class="channel-icon" src="../../../assets/image/joinUs/channel-2-icon.png" alt="">
            <div class="channel-label">社会招聘</div>
          </div>
        </div>
        <div class="channel-item" @click="toSchoolH5">
          <img class="channel_bg" src="../../../assets/image/Mobile/joinUs/joinUs_channel2.png" alt="">
          <div class="channel_text">
            <img class="channel-icon" src="../../../assets/image/joinUs/channel-1-icon.png" alt="">
            <div class="channel-label">校园招聘</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <ecn-title title="为什么选择医智诺"></ecn-title>
      <div style="padding: 148px 54px 0;">
        <div style="height: 120px;"></div>
        <div class="leval_content">
          <img class="level_img" src="../../../assets/image/Mobile/joinUs/joinUs_content1.png" alt="">
          <div class="title">因材施教的培训体系</div>
          <div class="msg">医智诺致力于打造学习型组织，为员工提供最契合的培训，帮助初入职场的你从容应对各种问题，轻松掌控工作节奏。</div>
        </div>
        <div class="flow_content">
          <img src="../../../assets/image/Mobile/joinUs/joinUs_content2.png" alt="">
          <div class="title">得天独厚的发展优势</div>
          <div class="msg">医智诺是香港上市公司弘毅文化集团（HK00419）旗下的医疗集团，控股子公司。</div>
        </div>
        <div style="height: 120px;"></div>
        <div class="leval_content">
          <img class="level_img" src="../../../assets/image/Mobile/joinUs/joinUs_content3.png" alt="">
          <div class="title">无微不至的福利关怀</div>
          <div class="msg">在医智诺你的努力不会被忘记，你的付出将会被真诚对待，舒适的办公环境，极具竞争力的薪酬、足额五险一金、试用期全额工资和股权激励体系，只为回报你的尽心拼搏。</div>
        </div>
        <div class="flow_content">
          <img src="../../../assets/image/Mobile/joinUs/joinUs_content4.png" alt="">
          <div class="title">积极正向的发展目标</div>
          <div class="msg">医智诺致力于布局全产业医疗服务生态圈，搭建全场景化医疗服务平台，平台未来5年提供直接岗位10000+、间接岗位10000+，市值将达到1000亿，孵化出6家创新企业。</div>
        </div>
        <div class="pic_show">
          <div class="row_slider">
            <div class="content-item1">
              <el-carousel arrow="never" :interval=intervalNum1 indicator-position="none" height="24.39vw">
                <el-carousel-item v-for="(item, idx) in swiperContent1" :key="idx">
                  <img :src="item.path" alt="">
                  <p class="swiper-title">{{ item.name }}</p>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="content-item2">
              <el-carousel arrow="never" :interval=intervalNum2 indicator-position="none" height="24.39vw">
                <el-carousel-item v-for="(item, idx) in swiperContent2" :key="idx">
                  <img :src="item.path" alt="">
                  <p class="swiper-title">{{ item.name }}</p>
                </el-carousel-item>
              </el-carousel>
            </div>

            <div class="content-item2">
              <el-carousel arrow="never" :interval=intervalNum2 indicator-position="none" height="24.39vw">
                <el-carousel-item v-for="(item, idx) in swiperContent3" :key="idx">
                  <img :src="item.path" alt="">
                  <p class="swiper-title">{{ item.name }}</p>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="content-item1">
              <el-carousel arrow="never" :interval=intervalNum1 indicator-position="none" height="24.39vw">
                <el-carousel-item v-for="(item, idx) in swiperContent4" :key="idx">
                  <img :src="item.path" alt="">
                  <p class="swiper-title">{{ item.name }}</p>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import envimg1 from "../../../assets/image/joinUs/env-company-pic1.png"
import envimg2 from "../../../assets/image/joinUs/env-company-pic2.png"

import sportImg1 from "../../../assets/image/joinUs/sport-pic1.png"
import staffImg1 from "../../../assets/image/joinUs/staff-pic1.png"

import readBookImg1 from "../../../assets/image/joinUs/readingBook-pic1.png"
import birthdayImg1 from "../../../assets/image/joinUs/birthday-pic1.png"

import holidayImg1 from "../../../assets/image/joinUs/holiday-pic1.png"
import familyImg1 from "../../../assets/image/joinUs/family-benefits-pic1.png"
export default {
  data() {
    return {
      intervalNum1: 3500,
      intervalNum2: 4000,
      swiperContent1: [//图片展示多条不会出现倒置的现象
        {
          name: '5A办公环境',
          path: envimg1
        },
        {
          name: '5A办公环境',
          path: envimg2
        },
        {
          name: '5A办公环境',
          path: envimg1
        },
        {
          name: '5A办公环境',
          path: envimg2
        }
      ],
      swiperContent2: [
        {
          name: '五星健身年卡',
          path: sportImg1
        },
        {
          name: '员工团建',
          path: staffImg1
        },
        {
          name: '五星健身年卡',
          path: sportImg1
        },
        {
          name: '员工团建',
          path: staffImg1
        }
      ],
      swiperContent3: [
        {
          name: '公司读书角',
          path: readBookImg1
        },
        {
          name: '生日/贺仪',
          path: birthdayImg1
        },
        {
          name: '公司读书角',
          path: readBookImg1
        },
        {
          name: '生日/贺仪',
          path: birthdayImg1
        }
      ],
      swiperContent4: [
        {
          name: '带薪假期',
          path: holidayImg1
        },
        {
          name: '家属福利',
          path: familyImg1
        },
        {
          name: '带薪假期',
          path: holidayImg1
        },
        {
          name: '家属福利',
          path: familyImg1
        }
      ],
    }
  },
  methods: {
    toRecruit(){
      this.routerJump("/recruit_mobile")
    },
    routerJump(m){
      let header = document.getElementById('app')
      header.scrollTop = 0
      this.$store.commit('changeActiveMenu',m)
      this.$emit('closemenu',{})
      window.scrollTo(0,0)
      this.$router.push({path:m})
    },
    toSchoolH5(){
      window.location.href = 'https://h5.clewm.net/?url=qr61.cn%2Fo1amrz%2FqfN2YJA&hasredirect=1';
    }
  }
}
</script>
<style scoped lang="scss">
.project-app {

  .solution-cont {
    background-image: url('../../../assets/image/Mobile/joinUs/joinUs_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 53vw;
    padding-left: 54px;

    .banner-title {
      font-size: 72px;
      line-height: 93px;
      letter-spacing: 8px;
      color: #FFFFFF;
      font-family: YouSheBiaoTiHei;
      text-shadow: 0px 0px 6px rgba(6, 58, 148, 0.5);
      padding-top: 21vw;
    }

    .banner-message {
      font-size: 30px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      color: #FFFFFF;
      line-height: 36px;
      letter-spacing: 12px;
      text-shadow: 0px 0px 6px rgba(6, 58, 148, 0.5);
      margin-top: 20px;
    }
  }

  .card {
    padding-top: 120px;
    overflow: hidden;
  }

  .recruit_channel {
    padding-top: 102px;
    display: flex;
    justify-content: center;

    .channel-item {
      width: 43vw;
      text-align: center;
      position: relative;

      .channel_bg {
        width: 100%;
      }

      .channel_text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .channel-icon {
          width: 6vw;
          margin-bottom: 10px;
        }

        .channel-label {
          font-size: 36px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          color: #FFFFFF;
          line-height: 54px;
          letter-spacing: 2px;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
        }
      }
    }
  }

  .leval_content {
    background: linear-gradient(136deg, #BDD1FE 0%, #3771E0 100%);
    padding: 34vw 36px 48px;
    position: relative;
    margin-bottom: 102px;

    .level_img {
      width: 86%;
      position: absolute;
      left: 0;
      top: -120px;
    }

    .title {
      font-size: 48px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fff;
      line-height: 69px;
      letter-spacing: 3px;
      margin-bottom: 24px;
    }

    .msg {
      font-size: 42px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      text-align: justify;
      color: #fff;
      line-height: 60px;
      letter-spacing: 2px;
    }
  }

  .flow_content {
    margin-bottom: 102px;
    background: #F9F9FD;
    padding-bottom: 33px;

    img {
      width: 100%;
    }

    .title {
      padding: 54px 36px 24px;
      font-size: 48px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 69px;
      letter-spacing: 3px;
    }

    .msg {
      padding: 0 36px;
      font-size: 42px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      text-align: justify;
      color: #333333;
      line-height: 60px;
      letter-spacing: 2px;
    }
  }

  .pic_show {
    margin-bottom: 150px;

    .row_slider {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      gap: 4vw;

      .content-item1 {
        width: 51.76vw;
        overflow: hidden;
        position: relative;

        img {
          width: 100%;
        }
      }

      .content-item2 {
        width: 31.86vw;
        overflow: hidden;
        position: relative;

        img {
          width: 100%;
        }
      }
      .swiper-title{
        position: absolute;
        left: 20px;
        top: 16px;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        color: #FFFFFF;
        line-height: 54px;
      }
    }
  }

  .ecn-title ::v-deep {
    padding-left: 54px;

    .title {
      font-size: 54px;
      line-height: 54px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      color: #333;
      letter-spacing: 3px;
    }

    .line {
      width: 84px;
      height: 18px;
      margin-top: 24px;
    }
  }
}
</style>
